<div class="post-stay-tuned">
  <div class="post-stay-tuned__title text-base-font-primary" translate>global.stay-tuned</div>
  <div class="post-stay-tuned__container">
    <a
      class="border-b-8 post-stay-tuned__post border-b-base-green"
      [routerLink]="['/post', item.id]"
      *ngFor="let item of data"
      target="_blank"
    >
      <ng-container *ngIf="showDesktop$ | async; else summaryTemplate">
        <img class="post-stay-tuned__image" loading="lazy" [src]="item.imagem_desktop" [alt]="item.titulo" />
      </ng-container>
      <ng-template #summaryTemplate>
        <img
          class="post-stay-tuned__image"
          loading="lazy"
          [src]="item.imagem_mobile ?? item.imagem_desktop"
          [alt]="item.titulo"
        />
      </ng-template>
      <div class="post-stay-tuned__info">
        <p>{{ item.titulo }}</p>
        <span>{{ item.chamada }}</span>
      </div>
    </a>
  </div>
</div>
